import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import { ReportChartOptions } from 'src/app/shared/classes/chart-report';
import {AdRequestParams} from 'src/app/shared/interfaces/ad-reports';
import {FullscreenService} from '../../../../shared/services/fullscreen.service';
import {delay, tap} from 'rxjs/operators';
import {ReportUtils} from '../../../../shared/libraries/report-utils';
import {ReportChartStore} from '../../../../shared/store/report/report-chart.store';
import {ReportStore} from '../../../../shared/store/report/report.store';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, AfterViewInit, OnDestroy {
  public  fullscreen:     boolean;
  public  show:           boolean =             true;

  private fullscreenSubs: Subscription;

  public readonly loading$: Observable<boolean> = this._reportChartStore.loading$;
  public readonly options$: Observable<ReportChartOptions> = this._reportChartStore.options$;
  public readonly dimensionValues$: Observable<Array<string>> = this._reportChartStore.dimensionValues$;
  public readonly config$: Observable<any> = this._reportChartStore.config$;
  public readonly params$: Observable<Partial<AdRequestParams>> = this._reportStore.requestParams$;
  public readonly loaded$: Observable<boolean> = this._reportChartStore.loaded$;

  constructor(
    private readonly fullscreenS: FullscreenService,
    private readonly _reportStore: ReportStore,
    private readonly _reportChartStore: ReportChartStore
  ) { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
   this.fullscreenSubs = this.fullscreenS.onFullscreen$
      .pipe(
        tap(() => {
          this.show = false;
        }),
        delay(0)
      )
      .subscribe(() => {
        this.show = true;
      });
  }

  ngOnDestroy(): void {
    ReportUtils.unsubscribe(this.fullscreenSubs);
  }

}
